import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  templateUrl: "./export-info-dialog.component.html",
  styleUrls: ["./export-info-dialog.component.scss"],
})
export class ExportInfoDialogComponent {
  constructor(private dialogRef: MatDialogRef<ExportInfoDialogComponent>) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close(true);
  }
}
